// extracted by mini-css-extract-plugin
export var paginationContainer = "_78-0";